import { useCallback, useEffect } from 'react';
import {
  useParams, useSearchParams,
} from 'react-router-dom';
import { SEARCH_ROUTE } from 'Utils/Constants';
import { setSessionStorageValue } from 'Utils/UtilityFunctions';

const SalesforceRouter = function SalesforceRouter() {
  const { section } = useParams();
  const [searchParams] = useSearchParams();
  console.log('route', section, searchParams);

  const appName = searchParams.get('appName');

  const accountName = searchParams.get('accountName') ?? '';
  const website = searchParams.get('website') ?? '';
  const contactName = searchParams.get('contactName') ?? '';
  const email = searchParams.get('email');
  const app = searchParams.get('app');
  const objectName = searchParams.get('object_name');
  const xiqCompanyId = searchParams.get('xiq_company_id');
  const xiqPersonId = searchParams.get('xiq_person_id');
  const orgId = searchParams.get('org_id');
  const recordId = searchParams.get('record_id');
  const pageType = searchParams.get('pageType');
  const username = searchParams.get('username');
  const showHeader = searchParams.get('showHeader');

  const init = useCallback(() => {
    if (appName) {
      setSessionStorageValue('appName', appName);
    }
    if (email) {
      setSessionStorageValue('email', email);
    }
    if (app) {
      setSessionStorageValue('app', app);
    }
    if (objectName) {
      setSessionStorageValue('objectName', objectName);
    }
    if (xiqCompanyId) {
      setSessionStorageValue('xiqCompanyId', xiqCompanyId);
    }
    if (xiqPersonId) {
      setSessionStorageValue('xiqPersonId', xiqPersonId);
    }
    if (orgId) {
      setSessionStorageValue('orgId', orgId);
    }
    if (recordId) {
      setSessionStorageValue('recordId', recordId);
    }
    if (pageType) {
      setSessionStorageValue('pageType', pageType);
    }
    if (username) {
      setSessionStorageValue('username', username);
    }
    if (showHeader) {
      setSessionStorageValue('username', showHeader);
    }
    if (section) {
      let route = '/feed';

      if (section === 'company') {
        if (website && website.length && website !== 'null') {
          route = `${SEARCH_ROUTE}${encodeURIComponent(website)}&extend=${section}`;
        } else if (accountName && accountName.length) {
          route = `${SEARCH_ROUTE}${encodeURIComponent(accountName)}${website.length && website !== 'null' ? `%20${encodeURIComponent(website)}` : ''}&extend=${section}`;
        }
      } else if (section === 'person') {
        if (contactName.length && accountName.length && accountName !== 'null') {
          route = `${SEARCH_ROUTE}${encodeURIComponent(contactName)}%20${encodeURIComponent(accountName)}&extend=${section}`;
        } else {
          route = `${SEARCH_ROUTE}${encodeURIComponent(contactName)}&extend=${section}`;
        }
      }
      setSessionStorageValue('initialRoute', window.location.pathname + window.location.search);

      window.location.href = route;
    }
  }, [section, searchParams]);

  useEffect(() => {
    init();
  }, []);

  return <div />;
};

export default SalesforceRouter;
